<template>
    <div class="DiaLog">
        <el-form ref="form" :model="form" :rules="rules" label-width="auto" label-position="right" size="small">
            <el-row>
                <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
                    <el-form-item label="小区名称：" prop="name" :class="{'screen': isReadonly}">
                        <el-input v-model="form.name"  :readonly="isReadonly"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" :offset="1">
                    <el-form-item label="状态：">
                        <el-switch v-model="form.status === 1" :disabled="isReadonly" @change="change"></el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
                    <el-form-item label="负责人：" prop="legal_name" :class="{'screen': isReadonly}">
                        <el-input v-model="form.legal_name"  :readonly="isReadonly"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" :offset="1">
                    <el-form-item label="联系电话：" prop="legal_tel" :class="{'screen': isReadonly}">
                        <el-input v-model="form.legal_tel" :readonly="isReadonly"  onkeyup="this.value=this.value.replace(/[^\0-9]/g, '')" maxlength="11"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
                    <el-form-item label="物业归属地：" prop="province_code" :class="{'screen': isReadonly}">
                        <el-cascader
                            v-model="area"
                            :options="areaOptions"
                            @change="areaChange"
                            :disabled="isReadonly"
                            :style="{width: isReadonly === true ? '376px' : '100%'}">
                        </el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" :offset="1">
                    <el-form-item label="物业地址：" prop="register_address" class="address" :class="{'screen': isReadonly}">
                        <el-input id="register_address" v-model="form.register_address" :readonly="isReadonly" placeholder="请输入物业地址" style="width: 100%"></el-input>
                        <el-button type="primary" class="get" @click="search" v-show="!isReadonly">获取</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-row>
            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" :offset="2">
                <div id="map"></div>
            </el-col>
        </el-row>
        <br>
        <br>
        <el-row v-show="isReadonly === false">
            <el-col :span="23" class="right">
                <el-button size="small" @click="cancel">取消</el-button>
                <el-button size="small" type="primary" @click="submit">提交</el-button>
            </el-col>
        </el-row>
        <el-row v-show="isReadonly === true">
            <el-col :span="23" class="right" v-show="isExamine === true">
                <el-button size="small" @click="examine(2)">驳回</el-button>
                <el-button size="small" type="primary" @click="examine(1)">通过</el-button>
            </el-col>
            <el-col :span="23" class="right" v-show="isExamine === false">
                <el-button size="small" @click="cancel">关闭</el-button>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { regionData, CodeToText } from "element-china-area-data";
import AMapLoader from '@amap/amap-jsapi-loader';
window._AMapSecurityConfig = {
  securityJsCode: "a001e7f550e51a75709e3cb08696ee91",
};
export default {
    name: 'Dialog',
    data() {
        var checkPhone = (rule, value, callback) => {
            var reg = /^1[3456789]\d{9}$/;
            if(reg.test(value) === false){
                callback(new Error('手机号格式有误'));
            }else{
                callback();
            }
        };
        return {
            rules:{
                name: [
                    {
                        required: true, message: '请输入小区名称', trigger: 'blur'
                    }
                ],
                legal_name: [
                    {
                        required: true, message: '请输入负责人姓名', trigger: 'blur'
                    }
                ],
                legal_tel: [
                    {
                        required: true, message: '请输入负责人联系电话', trigger: 'blur'
                    },
                    { validator: checkPhone, trigger: "blur" }
                ],
                province_code: [
                    {
                        required: true, message: '请选择物业归属地', trigger: 'change'
                    }
                ],
                province_name: [
                    {
                        required: true, message: '请选择物业归属地', trigger: 'change'
                    }
                ],
                city_code: [
                    {
                        required: true, message: '请选择物业归属地', trigger: 'change'
                    }
                ],
                city_name: [
                    {
                        required: true, message: '请选择物业归属地', trigger: 'change'
                    }
                ],
                area_code: [
                    {
                        required: true, message: '请选择物业归属地', trigger: 'change'
                    }
                ],
                area_name: [
                    {
                        required: true, message: '请选择物业归属地', trigger: 'change'
                    }
                ],
                register_address: [
                    {
                        required: true, message: '请获取物业地址', trigger: 'blur'
                    }
                ],
                longitude: [
                    {
                        required: true, message: '请点击获取按钮以获取物业地址', trigger: 'blur'
                    }
                ],
                latitude: [
                    {
                        required: true, message: '请点击获取按钮以获取物业地址', trigger: 'blur'
                    }
                ],
            },
            areaOptions: regionData,
            area: [],

            // 地图相关
            theMap: null, //AMap对象
            map: null, //地图
            zoom: 11,
            lng: this.form.longitude ? this.form.longitude : 116.473179,
            lat: this.form.latitude ? this.form.latitude : 39.993169,
            autoOptions: {
                input: "register_address",
            },
            auto: null,
            placeSearch: null,
        }
    },
    props:{
        form: Object,
        isReadonly: {
            type: Boolean,
            default: false
        },
        isExamine: {
            type: Boolean,
            default: false
        }
    },
    watch:{
        'form.longitude'(){
            if(this.form.longitude === '' && this.form.latitude === ''){
                this.$refs.form.clearValidate();
                this.area = '';
                this.resetMap();
            }
        },
        'form.id'(){
            if(this.form.id && this.form.id != ''){
                this.area = [`${this.form.province_code}`, `${this.form.city_code}`, `${this.form.area_code}`];
                this.setMarker(this.form.longitude, this.form.latitude, this.form.register_address, this.theMap);
            }
        },
        'form.province_code'(){
            if(this.form.province_code === '' || this.form.city_code === '' || this.form.area_code === ''){
                this.area = '';
            }
        }
    },
    created() {
        if(this.form.id){
            this.area = [`${this.form.province_code}`, `${this.form.city_code}`, `${this.form.area_code}`];  
        }
    },
    mounted(){
        if(this.form.id){
            this.initMap(this.form.longitude, this.form.latitude, this.form.register_address);
        }else{
            this.initMap();
        }
    },
    methods: {
        areaChange(value) {
            this.form.province_code = value[0];
            this.form.city_code = value[1];
            this.form.area_code = value[2];

            this.form.province_name = CodeToText[value[0]];
            this.form.city_name = CodeToText[value[1]];
            this.form.area_name = CodeToText[value[2]];
            if(!this.form.register_address){
                this.setMapCenter(this.form.province_name + this.form.city_name + this.form.area_name);
            }
        },
        async initMap(lng, lat, name){
            await AMapLoader.load({
                key:"8d95231ab4ac2b3f5a2852be1e8af140",             // 申请好的Web端开发者Key，首次调用 load 时必填
                version:"2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins:[
                    "AMap.Geolocation",
                    "AMap.Geocoder",
                    "AMap.AutoComplete",
                    "AMap.PlaceSearch",
                ],   // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap)=>{
                this.theMap = AMap;
                this.map = new AMap.Map("map", {  //设置地图容器id
                    zoom: this.zoom,           //初始化地图级别
                    center:[this.lng, this.lat], //初始化地图中心点位置
                });

                this.auto = new AMap.AutoComplete(this.autoOptions);
                this.placeSearch = new AMap.PlaceSearch();
                this.auto.on("select", (e) => {
                    this.select(e);
                });
                if(lng && lat && name){
                    this.setMarker(lng, lat, name, AMap);
                }
                var geocoder = new AMap.Geocoder({
                    radius: 500 //范围，默认：500
                });
                this.map.on('click', e => {
                    if(this.isReadonly === true){
                        return;
                    }else{
                        geocoder.getAddress(e.lnglat, (status, result) => {
                            if (status === 'complete' && result.regeocode) {
                                console.log(e, result);
                                this.form.register_address = result.regeocode.formattedAddress;
                                this.form.longitude = e.lnglat.lng;
                                this.form.latitude = e.lnglat.lat;
                                this.setMarker(e.lnglat.lng, e.lnglat.lat, result.regeocode.formattedAddress, AMap);
                            }else{
                                this.$message.info('当前点击经纬度无效');
                            }
                        });
                    }
                });
            }).catch(e=>{
                console.log(e);
            })
        },
        // 自动补全时的下拉框
        select(e) {
            let lng = e.poi.location.lng,
                lat = e.poi.location.lat,
                name = e.poi.name;
            this.setMarker(lng, lat, name, this.theMap);
            this.$emit('setLngLat', {
                lng: lng,
                lat: lat,
                name: name
            });
        },
        // 点击搜索
        search(reWrite){
            let searchName = '';
            if(reWrite && typeof reWrite === 'string'){
                searchName = reWrite;
            }else{
                searchName = this.form.register_address;
            }
            this.placeSearch.search(searchName,(status,res) => {
                if(res.info === 'OK'){
                    let target = res.poiList.pois[0],
                        lng = target.location.lng,
                        lat = target.location.lat,
                        name = reWrite ? this.form.register_address : target.name;
                    this.setMarker(lng, lat, name, this.theMap);
                    this.$emit('setLngLat', {
                        lng: lng,
                        lat: lat,
                        name: name
                    });
                }else if(res.info === 'TIP_CITIES'){
                    if(this.area.length != 0){
                        let name = CodeToText[this.area[0]] + CodeToText[this.area[1]] + CodeToText[this.area[2]] + this.form.register_address;
                        this.search(name)
                    }else{
                        return this.$alert('未能获取到精准定位，请先选择所在区域', '提示', {
                            confirmButtonText: '确定'
                        });
                    }
                }
                
            });
        },
        // 设置marker
        setMarker(lng, lat, name, AMap){
            this.lng = lng;
            this.lat = lat;
            this.address = name;
            let marker = new AMap.Marker({
                position: [lng, lat]
            });
            let infoWindow = new AMap.InfoWindow({
                autoMove: true,
                offset: {x: 0, y: -30},
                content: `地址：${name}`
            });
            this.map.clearMap();
            infoWindow.open(this.map, [lng, lat]);
            this.map.add(marker);
            this.map.setFitView();
            
        },
        // 选择所在省市区后设置地图中心点
        setMapCenter(name){
            this.placeSearch.search(name,(status,res) => {
                console.log(res);
                if(res.info == 'OK'){
                    let target = res.poiList.pois[0],
                        lng = target.location.lng,
                        lat = target.location.lat;
                    this.map.clearMap();
                    this.map.setCenter([lng, lat]);
                }
            });
        },     
        // 修改状态
        change(){
            if(this.form.status === 1){
                this.form.status = 2;
            }else{
                this.form.status = 1;
            }
        },
        submit(){
            this.$refs.form.validate(v => {
                if(v === true){
                    this.$emit('submit');
                }else{
                    return this.$message.error('请将必填项填写完整');
                }
            })
        },
        cancel(){
            this.area = '';
            this.$refs.form.clearValidate();
            this.resetMap();
            this.$emit('close');
        },
        resetMap(){
            this.map.clearMap();
            this.lng = 116.473179;
            this.lat = 39.993169;
            this.map.setCenter([this.lng, this.lat]);
            this.map.setZoom(this.zoom);
        },
        // 审核
        examine(statu){
            this.$emit('examine', statu);
        }
    },
}
</script>
<style lang="less" scoped>
    .DiaLog{
        #map{
            // margin-left: 140px;
            height: 400px;
        }
        .address{
            /deep/.el-form-item__content{
            display: flex;
            align-items: center;

            }
        }
        .floor{
            margin-bottom: 40px;
            .floor-title{
                margin: 20px 0;
                padding-left: 20px;
                font-size: 18px;
                font-weight: bold;
                color: #000;
                border-left: 3px solid var(--main-theme-color);
            }

            .upload{
                .uploadFile{
                    margin-left: 28px;
                    width: 340px;
                    height: 200px;
                    background: #fafafa;
                    cursor: pointer;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
        .right{
            text-align: right;
        }

        .screen:focus-within,
        .screen:hover{
            border-color: transparent;
            background-color: #f4f5f7;
            color: #989898;
        }
    }
    
</style>